export const category_product_full_description = "category_product_full_description";
export const category_product_name_price_cal = "category_product_name_price_cal";
export const category_hide_products = "category_hide_products";
export const category_product_as_option = "category_product_as_option";
export const category_with_ad_logo_small = "category_with_ad_logo_small";
export const feature = "feature";
export const legend = "legend";
export const disclaimer = "disclaimer";
